import React from 'react'
import day from 'dayjs'
import { WorkMergeRequestSummary } from '@Entities/rightsholder/work-merge'
import WorkMergeStatusPill from '@Scenes/RightsholderScene/WorkMerge/WorkMergeStatusPill'
import './index.scss'

interface WorkMergeRequestCardProps {
    request: WorkMergeRequestSummary
    dateLabel: string
    onViewRequest?(): void
}

const WorkMergeRequestCard = ({ request, dateLabel, onViewRequest }: WorkMergeRequestCardProps) => {
    const fields = [
        { label: 'MLC Song Code', value: request.primarySongCode },
        { label: dateLabel, value: day(request.submittedAt).format('MMMM D, YYYY') },
        { label: 'Requested By', value: request.submittedBy },
        { label: 'Primary Work Title', value: request.primaryWorkTitle },
        { label: 'Works Merged', value: `${request.secondaryWorkCount}` },
    ]

    return (
        <div className="work-merge-request-card">
            <div className="work-merge-request-card-fields">
                {fields.map((field) => (
                    <div className="work-merge-request-card-field" key={field.label}>
                        <span className="work-merge-request-card-field-label">{field.label}</span>
                        <span className="work-merge-request-card-field-value">{field.value}</span>
                    </div>
                ))}
            </div>
            <div className="work-merge-request-card-actions">
                <button className="work-merge-request-card-view" type="button" onClick={onViewRequest}>
                    View Request
                </button>
                <WorkMergeStatusPill status={request.status} />
            </div>
        </div>
    )
}

export default WorkMergeRequestCard
